import { Navigate, Routes, Route } from "react-router-dom";
import Home from "./MainComponents/Home";
import CreatorLogin from "./MainComponents/CreatorLogin";
import CreatorPortal from "./MainComponents/CreatorPortal";
import TermsNC from "./MainComponents/TermsNC";
import PrivacyPolicy from "./MainComponents/PrivacyPolicy";
import Services from "./MainComponents/Services";
import Paynow from "./MainComponents/Paynow";
import RefundPolicy from "./MainComponents/RefundPolicy";
import ClientDetails from "./MainComponents/ClientDetails";
import PaymentFailed from "./MainComponents/PaymentFailed";
import PaymentSuccessful from "./MainComponents/PaymentSuccessful";
import PaymentGenerator from "./MainComponents/PaymentGenerator";
import AddDataToQRCode from "./MainComponents/AddDataToQRCode";
import GenerateCoupons from "./NFC/GenerateCoupons";
import NfcUsers from "./NFC/NfcUsers";
import ManageStores from "./POS/ManageStores";

const CustomeRoutes = () => {
  return (
    <Routes>
      {/* home */}
      <Route path="/" element={<Navigate to="/payment-home" />} />
      <Route path="/payment-home" element={<Home />} />
      <Route path="/terms-n-conditions" element={<TermsNC />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/refund-policy" element={<RefundPolicy />} />

      {/* admin */}
      <Route path="/login-creator" element={<CreatorLogin />} />

      <Route path="/creator-portal" element={<CreatorPortal />} />

      <Route path="/nfc-users" element={<NfcUsers />} />
      <Route path="/generate-coupons" element={<GenerateCoupons />} />

      <Route path="/creator-client-details" element={<ClientDetails />} />
      <Route path="/payment-generator" element={<PaymentGenerator />} />
      <Route path="/creator-services" element={<Services />} />
      
      <Route path="/create-qr" element={<AddDataToQRCode />} />

      {/* payment */}
      <Route path="/paynow/:id" element={<Paynow />} />
      <Route path="/payment-failed" element={<PaymentFailed />} />
      <Route path="/payment-successful" element={<PaymentSuccessful />} />

      {/* pos */}
      <Route path="/manage-stores" element={<ManageStores />} />
    </Routes>
  );
};

export default CustomeRoutes;
